var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.data.class,attrs:{"id":_vm.id,"href":_vm.data.href},on:{"click":function($event){return _vm.$emit('clicked', _vm.$el)}}},[_vm._v(_vm._s(_vm.data.text))])}
var staticRenderFns = []

export { render, staticRenderFns }